














import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator';
import { FeedMessageEntity } from '@/api/types';
import linkify from 'linkifyjs/html';

@Component
export default class FeedReply extends Vue {

  @Prop()
  readonly message!: FeedMessageEntity;

  
}
